import React from 'react';
import PropTypes from 'prop-types';
import ViewPDFModal from 'components/_share/ViewPDFModal';
import { exportInvoiceReport } from 'services/invoice';
import ModalHeaderActions from './ModalHeaderActions';

const ViewModal = ({ data, checkIfActionAvailable, ...restProps }) => {
  const pdfRef = React.useRef();

  return (
    <ViewPDFModal
      ref={pdfRef}
      data={data}
      action={<ModalHeaderActions pdfRef={pdfRef} data={data} checkIfActionAvailable={checkIfActionAvailable} />}
      exportFunc={exportInvoiceReport}
      {...restProps}
    />
  );
};

ViewModal.defaultProps = {
  data: {}
};

ViewModal.propTypes = {
  data: PropTypes.object
};

export default ViewModal;
